@switch (creatorService.currentStep) {
  @case (1) {
    <app-work-step1></app-work-step1>
  }
  @case (2) {
    <app-work-step2></app-work-step2>
  }
  @case (3) {
    <app-work-step3></app-work-step3>
  }
}
